import React, { useContext, useEffect, useState, useRef } from 'react';
import Typography from '../../components/common/Typography';
import Button from '../../components/common/Button';

import { QuestionBox, AnswerBox, LoadingBox, FailBox, AnswerButton } from './ChatBoxes';
import TextField from '../../components/common/TextField';
import { useTranslation } from 'react-i18next';
import { AiAssistantStyled } from '../../asset/styled/AiAssistantStyled';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAuthInfo,
  setHasError,
  setIsLoading,
  setQContent,
  setQnaList,
} from './aiAssistantSlice';
import { getComYASetting } from '../resultQuery/resultQuerySlice';
import AlertContext from '../../context/AlertContext';
import MyInfo from '../myInfo';
import ScheduleScreen from '../main/Schedule';
import SlideDialogV from '../../components/common/SlideDialogV';
import { parseLinkButtons, LINK_PATTERN } from './utils';
import { AI_MESSAGE_RULES } from '../../common/data';

import sendIcon from '../../asset/img/send_msg_icon.svg';
import sendIconDis from '../../asset/img/send_msg_icon_dis.svg';
import callCenterIcon from '../../asset/img/ai_assistant_callcenter_icon.svg';

import aiInfoIcon from '../../asset/img/ai_info_icon02.svg';
import dogIcon from '../../asset/img/ai_assistant_dog_icon.svg';
import callIcon from '../../asset/img/ai_assistant_call_icon.svg';
import myInfoIcon from '../../asset/img/ai_assistant_myinfo_icon.svg';
import scheduleIcon from '../../asset/img/ai_assistant_cal_icon.svg';
import resultIcon from '../../asset/img/ai_assistant_result_icon.svg';
import callSmallIcon from '../../asset/img/ai_assistant_call_small_icon.svg';
import arrowSmallIcon from '../../asset/img/ai_arrow_small_Icon.svg';
import aiWatermarkIcon from '../../asset/img/ai_watermark.svg';

// AI 다이렉트 아이콘
import previousJobIcon from '../../asset/img/ai_direct_icon/previousJob.svg';
import insuranceIcon from '../../asset/img/ai_direct_icon/insurance.svg';
import medicalIcon from '../../asset/img/ai_direct_icon/medical.svg';
import educationIcon from '../../asset/img/ai_direct_icon/education.svg';
import donationIcon from '../../asset/img/ai_direct_icon/donation.svg';
import creditCardIcon from '../../asset/img/ai_direct_icon/creditCard.svg';
import housingIcon from '../../asset/img/ai_direct_icon/housing.svg';
import etcIcon from '../../asset/img/ai_direct_icon/etc.svg';
import pdfIcon from '../../asset/img/ai_direct_icon/pdf.svg';
import documentIcon from '../../asset/img/ai_direct_icon/document.svg';
import familyIcon from '../../asset/img/ai_direct_icon/family.svg';

let realTimeMsg = ''; // 실시간 메세지
let isRealTimeMsgStart = false; // 실시간 메세지 시작 여부
let isSystemMsg = false; // 시스템 메세지 여부
let currentChatList = []; // 현재 대화 내용
let lastIdx = 0; // 마지막 인덱스
let currentRequest = null; // 직전 웹소켓 요청 데이터 (오류 발생 시 재시도 위해 저장)
let isResponding = false; // 응답 중인지 여부
let linkSystemMsg = ''; // 링크 시스템 메시지 누적

const AiAssistant = ({ isOpen, setIsOpen }) => {
  /* ai 질답 채팅 영역 */
  const navigate = useNavigate();
  const { myInfo } = useSelector(state => state.myInfo);
  const htmComCd = myInfo?.htmComCd || '';
  const { callcenter, isCertify, magamFlag } = useSelector(state => state.common);
  const { comYASetting } = useSelector(state => state.resultQuery);
  const { t } = useTranslation('aiAssistant');
  const { t: tMain } = useTranslation('main');
  const dispatch = useDispatch();
  const { qnaList, qContent, authInfo, isLoading, hasError } = useSelector(
    state => state.aiAssistant,
  );
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);
  const ws = useRef(null);

  const formatDate = d => new Date(d).toISOString().slice(0, 10).replace(/-/g, '.');
  const today = formatDate(new Date());
  const userName = myInfo?.htmInsaPerNm || '사용자';
  const defaultSystemMsg = `${userName}님의 질문을 이해하고 있어요...`;

  const [systemMsg, setSystemMsg] = useState(defaultSystemMsg); // 답변 전, 시스템 메세지

  // 채팅상담 가능 여부 (magamFlag가 'L'이 아니고, htmYAChatType이 '1'일 때만 가능)
  const isChatAvailable = magamFlag !== 'L' && comYASetting?.htmYAChatType === '1';
  const [resFlag, setResFlag] = useState(false); // 응답 중인지 여부 (응답 중 아이콘 렌더링을 위함)
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [isMyInfoOpened, setMyInfoOpened] = useState(false);
  const [isSchOpened, setIsSchOpened] = useState(false);
  const [isConfirmOpened, setIsConfirmOpened] = useState(false);

  // 인증 정보 설정
  useEffect(() => {
    if (sStorage.getItem('sessionId')) {
      // 사번은 세션에 없는 경우가 있으므로 myInfo에서 줍줍
      dispatch(
        setAuthInfo({
          sessionId: sStorage.getItem('sessionId'),
          htmPerSabun: (myInfo && myInfo.htmPerSabun) || sStorage.getItem('htmpersabun') || '', // 새로고침할 경우, myInfo.htmPerSabun 없는 이슈로 인해 예외처리
          htmAlias: sStorage.getItem('htmAlias'),
          htmComCd: htmComCd,
          platformFlag: 'mobile',
        }),
      );
    } else {
      alertMessage(t('error.msg02'), 'error');
    }
    // 채팅상담 가능 여부 확인을 위한 설정 조회
    dispatch(getComYASetting());
  }, []);

  useEffect(() => {
    const chatArea = document.querySelector('.aiAssistantContent');
    if (chatArea && !isInputFocused) {
      chatArea.scrollTo({
        top: chatArea.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [qnaList, isInputFocused]);

  useEffect(() => {
    /* 모바일에서 키보드 노출될 때 (input에 포커싱 될 때), 안내 박스 안보이도록 처리 */
    // TODO: 보다 더 확실한 방법으로 수정 필요
    // TODO: (현재 sendQuestion 안타고 키보드 닫힐 때, setIsInputFocused(false) 안되어서 안내 박스 없는 현상 존재)
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );

    if (isMobile) {
      const input = document.querySelector('.qContentArea input');
      const handleFocus = () => setIsInputFocused(true);
      if (input) input.addEventListener('focus', handleFocus);

      return () => {
        if (input) input.removeEventListener('focus', handleFocus);
      };
    }
  }, []);

  useEffect(() => {
    /* WebSocket 연결 설정 */
    console.log('AiAssistant 마운트 ===');
    connectWebSocket();
    // 언마운트 시, WebSocket 종료로 인한 오류 발생 알림으로 인해 초기화
    dispatch(setHasError(false));

    // 첫 번째 메시지가 에러인 경우 대화 내용 초기화
    if (currentChatList.length > 0 && currentChatList[0].type === 'error') {
      currentChatList = [];
      dispatch(setQnaList([]));
    }

    return () => {
      console.log('AiAssistant 언마운트 ===');
      if (ws.current) {
        console.log('언마운트로 인한 WebSocket 종료 (onclose 제거)');
        ws.current.onclose = null; // 종료 이벤트 핸들러 제거 (정상 종료 시에도 오류 알림 뜨는 현상 해결)
        ws.current.close();
      }
      // AI 어시스턴트 창을 완전히 닫을 때만 초기화 (다른 창 이동 시에는 대화 내용 유지를 위함)
      if (!isOpen) {
        console.log('isOpen === false로 인한 전역 변수 초기화');
        initVars();
      }
    };
  }, [isOpen]);

  const sortAndSliceHistory = history => {
    // 깊은 복사 (원본 배열 보존)
    const sortedHistory = [...history].sort((a, b) => {
      return a.idx - b.idx; // 오름차순 정렬
    });
    return sortedHistory.slice(-10); // 최근 10개 메시지만 유지
  };

  const addErrorMessage = currentList => {
    // 마지막 메시지가 에러 메시지가 아닐 경우에만 새로운 에러 메시지 추가
    const lastMessage = currentList[currentList.length - 1];
    if (!lastMessage || lastMessage.type !== 'error') {
      return sortAndSliceHistory([
        ...currentList,
        { message: t('error.msg02'), type: 'error', idx: lastIdx + 1 },
      ]);
    }
    console.log('[addErrorMessage] currentList : ', currentList);
    return currentList;
  };

  const handleError = chatList => {
    const errorHistory = addErrorMessage(chatList);
    currentChatList = errorHistory;
    dispatch(setQnaList(errorHistory));
    dispatch(setHasError(true));
    dispatch(setIsLoading(false));
    setResFlag(false);
    isResponding = false;
    realTimeMsg = '';
    setSystemMsg(defaultSystemMsg);
    linkSystemMsg = '';
  };

  const connectWebSocket = () => {
    if (ws.current && ws.current?.readyState == WebSocket.OPEN) {
      console.log('WebSocket 연결 시도 전, 기존 연결 종료');
      ws.current.close();
    }

    console.log('WebSocket 시도중 ...');
    // ws.current = new WebSocket('ws://localhost:8282/api/yearend/chat');
    ws.current = new WebSocket('wss://edith-server.payday.co.kr/api/yearend/chat');

    ws.current.onopen = () => {
      console.log('WebSocket 연결 완료');
      console.log('[ws.current.onopen] currentChatList: ', currentChatList);
      console.log('[ws.current.onopen] currentRequest: ', currentRequest);
      // 재시도 또는 오류 발생 시, currentRequest 존재
      if (currentRequest) {
        currentChatList = currentChatList.filter(chat => chat.type !== 'error');

        // 재시도 시, 이전 내용과 함께 다시 질문 전송
        sendQuestion(true);
        dispatch(setIsLoading(true));
        dispatch(setHasError(false));
        currentRequest = null;
      }
    };

    ws.current.onmessage = event => {
      try {
        let response = event.data;

        /*
          SMS: 시스템 메세지(한 문장) 시작
          SME: 시스템 메세지(한 문장) 끝
          SOT: 답변 시작
          EOT: 답변 종료
        */

        if (response === 'EOT') {
          isResponding = false; // 응답 완료
          setResFlag(false);
          lastIdx += 1;
          // 대화 완료 시, currentChatList에 최종 메시지 추가
          currentChatList = sortAndSliceHistory([
            ...currentChatList,
            { message: realTimeMsg, type: 'A', idx: lastIdx },
          ]);

          console.log('[ws.current.onmessage] 응답 완료, currentChatList: ', currentChatList);
          console.log('[ws.current.onmessage] 응답 완료, realTimeMsg: ', realTimeMsg);
          realTimeMsg = ''; // 다음 메시지를 위해 초기화
          setSystemMsg(defaultSystemMsg);
          linkSystemMsg = '';
        } else {
          // 첫 응답이 시작될 때 응답중 true
          if (!isResponding) {
            isResponding = true;
            setResFlag(true);
          }

          // 에러 메시지 포함 여부 체크
          if (response.includes('"error"')) {
            console.error('[ws.current.onmessage] 서버 에러 응답:', response);
            ws.current.close(); // 웹소켓 연결 종료
            return;
          }

          /* 시스템(로딩) 메시지 처리 */
          if (response.includes('SMS')) {
            if (!isSystemMsg) {
              setSystemMsg(defaultSystemMsg);
            }
            isSystemMsg = true; // 시스템 메시지 시작
            setSystemMsg(response.replace('SMS', ''));
            return;
          } else if (response.includes('SME')) {
            isSystemMsg = false; // 시스템 메시지 종료
            return;
          } else if (isSystemMsg) {
            // 링크 형식인 시스템 메시지면 linkSystemMsg에 누적
            if (response.match(LINK_PATTERN)) {
              linkSystemMsg += response;
              setSystemMsg(linkSystemMsg);
            } else {
              setSystemMsg(prev => prev + response); // 일반 시스템 메시지는 기존대로
            }
            return;
          }

          /* 실제 메시지 처리 */
          if (response.includes('SOT')) {
            isRealTimeMsgStart = true;
          } else {
            if (isRealTimeMsgStart) {
              dispatch(setIsLoading(false));
              isRealTimeMsgStart = false;
            }
            realTimeMsg += response;

            // 현재 진행중인 메시지를 보여주기 위한 qnaList 임시 업데이트
            const tempList = [
              ...currentChatList,
              { message: realTimeMsg, type: 'A', idx: lastIdx + 1 },
            ];
            dispatch(setQnaList(tempList));
          }
        }
      } catch (error) {
        isResponding = false;
        handleError(currentChatList);
      }
    };

    ws.current.onclose = () => {
      console.log('WebSocket 연결 종료');
      handleError(currentChatList);
    };

    ws.current.onerror = error => {
      console.error('WebSocket 에러:', error);
      handleError(currentChatList);
    };
  };

  const sendQuestion = async (retry = false) => {
    // 재시도가 아닐 경우에만 qContent 체크
    if (!retry && !qContent.trim().length) {
      alertMessage(t('error.msg03'));
      return;
    }

    if (!isLoading && !isResponding) {
      setIsInputFocused(false);
      lastIdx += 1;

      let requestData;
      if (retry) {
        // 재시도
        // currentRequest가 있으면 currentRequest 전송
        if (currentRequest) {
          const filteredHistory = currentRequest.history.filter(item => item.type !== 'error');
          console.log('[sendQuestion] filteredHistory: ', filteredHistory);
          requestData = {
            ...currentRequest,
            history: filteredHistory,
          };
        }
      } else {
        // 일반 시도
        currentChatList = sortAndSliceHistory([
          ...currentChatList,
          { message: qContent, type: 'Q', idx: lastIdx },
        ]);

        requestData = {
          ...authInfo,
          history: currentChatList,
        };
      }

      dispatch(setQnaList(currentChatList));
      dispatch(setQContent(''));
      dispatch(setIsLoading(true));

      try {
        // 연결이 안된 경우 currentRequest 저장 후 리턴
        if (!ws.current || ws.current.readyState !== WebSocket.OPEN) {
          currentRequest = requestData;
          return;
        }
        // 연결된 경우 바로 전송
        console.log('[sendQuestion] 최종 요청 데이터: ', requestData);
        ws.current.send(JSON.stringify(requestData));
      } catch (error) {
        handleError(currentChatList);
      }
    } else {
      // 답변 진행 중일 경우 전송 X
      alertMessage('답변이 진행 중입니다.');
      return;
    }
  };

  const initVars = () => {
    // 전역변수 초기화
    realTimeMsg = '';
    currentChatList = [];
    lastIdx = 0;
    currentRequest = null;
    isResponding = false;
  };

  const handleReset = () => {
    // state 초기화
    dispatch(setQnaList([]));
    dispatch(setHasError(false));
    dispatch(setIsLoading(false));
    linkSystemMsg = ''; // 링크 시스템 메시지 초기화
    initVars(); // 전역변수 초기화
    connectWebSocket(); // 웹소켓 연결 재시도
  };

  const handleRetry = () => {
    dispatch(setHasError(false));
    dispatch(setIsLoading(true));

    console.log('[handleRetry] currentChatList: ', currentChatList);
    // 에러 메시지를 제외한 대화 내용만 필터링
    let filteredChatList = currentChatList.filter(chat => chat.type !== 'error');
    // 마지막 메시지가 답변(A)인 경우 제거
    if (filteredChatList.length > 0 && filteredChatList[filteredChatList.length - 1].type === 'A') {
      filteredChatList = filteredChatList.slice(0, -1);
    }
    console.log('[handleRetry] filteredChatList: ', filteredChatList);

    currentChatList = filteredChatList;
    dispatch(setQnaList(filteredChatList));

    currentRequest = {
      ...authInfo,
      history: filteredChatList,
    };
    connectWebSocket();
  };

  const openGitple = () => {
    navigate('/chat');
  };

  const goToResult = () => {
    // 먼저 컴포넌트를 닫고 페이지 이동
    setIsOpen(false);
    navigate('/resultQuery');
    // 컴포넌트 언마운트 완료 후 초기화하기 위해 비동기 처리
    Promise.resolve().then(() => {
      handleReset();
    });
  };

  const handleResultViewClick = () => {
    /* 초기화를 위한 결과조회 클릭 시, 서류 제출이 완료되었을 경우에만 이동하도록 처리 */
    if (!isCertify) {
      alertMessage(
        <>
          아직 서류 제출이 완료되지 않았습니다.
          <br />
          초기화는 서류 제출 후 가능합니다.
        </>,
        'error',
      );
    } else {
      setIsConfirmOpened(true);
    }
  };

  const handleCallCenter = () => {
    if (!callcenter) {
      alertMessage(tMain('callCenterErrorMsg01'), 'error');
      return;
    }

    try {
      // 앱 환경 체크 (window.ReactNativeWebView가 있다면 앱 환경)
      if (window?.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'OPEN_URL', // 메시지 타입 수정
            url: `tel:${callcenter}`,
          }),
        );
        return;
      } else {
        //일반 웹 환경
        const telUrl = `tel:${callcenter}`;
        const link = document.createElement('a');
        link.href = telUrl;
        link.click();
      }
    } catch (error) {
      alertMessage(
        <>
          전화 연결 중 오류가 발생했습니다.
          <br />
          상담 전화번호: {callcenter}
        </>,
        'error',
      );
    }
  };

  // 아이콘 매핑 객체
  const iconMap = {
    result: resultIcon,
    callSmall: callSmallIcon,
    callCenter: callCenterIcon,
    myInfo: myInfoIcon,
    schedule: scheduleIcon,
    // AI 다이렉트 아이콘
    previousJob: previousJobIcon,
    insurance: insuranceIcon,
    medical: medicalIcon,
    education: educationIcon,
    donation: donationIcon,
    creditCard: creditCardIcon,
    housing: housingIcon,
    etc: etcIcon,
    pdf: pdfIcon,
    document: documentIcon,
    family: familyIcon,
  };

  const checkMessageFlags = message => {
    const flags = AI_MESSAGE_RULES.filter(rule => {
      const { keywords, condition } = rule;
      return keywords[condition](keyword => message.includes(keyword));
    }).map(rule => rule.flag);

    // 중복 제거를 위해 Set 사용 후 다시 배열로 변환
    return [...new Set(flags)];
  };

  // 다이렉트링크 이동 함수
  const handleDirectLink = link => {
    navigate(link);
  };

  const renderAnswerButtons = flags => {
    if (flags.length === 0) return null;

    const allButtons = []; // 각 flag에 해당하는 버튼들을 모아서 반환

    // flag 1: 채팅상담 & 전화상담 (isChatAvailable일 때만 표시)
    if (flags.includes(1) && isChatAvailable) {
      allButtons.push(
        <>
          <AnswerButton
            {...{
              onClick: openGitple,
              text: '채팅상담',
              icon: callSmallIcon,
            }}
          />
          {callcenter && (
            <AnswerButton
              {...{
                onClick: handleCallCenter,
                text: '전화상담',
                icon: callCenterIcon,
              }}
            />
          )}
        </>,
      );
    }

    // flag 2: 내정보
    if (flags.includes(2)) {
      allButtons.push(
        <AnswerButton
          {...{
            onClick: () => setMyInfoOpened(true),
            text: '내정보',
            icon: myInfoIcon,
          }}
        />,
      );
    }

    // flag 3: 연말정산 일정
    if (flags.includes(3)) {
      allButtons.push(
        <AnswerButton
          {...{
            onClick: () => setIsSchOpened(true),
            text: '연말정산 일정',
            icon: scheduleIcon,
          }}
        />,
      );
    }

    // flag 4: 결과조회 (초기화)
    if (flags.includes(4)) {
      allButtons.push(
        <AnswerButton
          {...{
            onClick: handleResultViewClick,
            text: '제출 및 결과조회',
            icon: resultIcon,
          }}
        />,
      );
    }

    // flag 5: 앱 설치
    if (flags.includes(5)) {
      allButtons.push(
        <AnswerButton
          {...{
            onClick: handleAppInstallClick,
            text: '앱 설치',
            icon: resultIcon, // TODO: 앱 설치 전용 아이콘으로 교체 필요
          }}
        />,
      );
    }

    // flag 6~12: 다이렉트링크 버튼 (AI_MESSAGE_RULES에서 link가 있는 항목 처리)
    AI_MESSAGE_RULES.filter(rule => rule.link && flags.includes(rule.flag)).forEach(rule => {
      allButtons.push(
        <AnswerButton
          {...{
            onClick: () => handleDirectLink(rule.link),
            text: rule.linkText,
            icon: iconMap[rule.iconKey] || resultIcon,
          }}
        />,
      );
    });

    return allButtons;
  };

  return (
    <>
      <AiAssistantStyled>
        <div className={'aiAssistantContent noneScroll'}>
          {/* 전문 상담사 버튼 - 대화가 있을 때만 상단에 표시 */}
          {qnaList && qnaList.length > 0 && isChatAvailable && (
            <div className={'consultantBtnContainer'}>
              <div className={'consultantBtn'} onClick={openGitple}>
                <img src={callSmallIcon} alt={'callSmallIcon'} />
                <Typography variant={'body2Medium'}>{t('consultantBtn')}</Typography>
                <img src={arrowSmallIcon} alt={'arrowSmallIcon'} />
              </div>
            </div>
          )}
          {/* AI 워터마크 - 대화 전에만 표시 */}
          {(!qnaList || qnaList.length === 0) && !isLoading && (
            <div className={'aiWatermark'}>
              <img src={aiWatermarkIcon} alt="AI" />
              <div className={'watermarkText'}>
                <span className={'watermarkTitle'}>AI가 빠른 답변으로 도와드려요.</span>
                {isChatAvailable && (
                  <span className={'watermarkDesc'}>
                    필요하신 경우 전문 상담사와 연결할 수 있어요.
                  </span>
                )}
              </div>
              {isChatAvailable && (
                <div className={'watermarkCounselorBtn'} onClick={openGitple}>
                  <img src={callSmallIcon} alt={'callSmallIcon'} />
                  <span>전문 상담사와 대화할래요!</span>
                  <img src={arrowSmallIcon} alt={'arrowSmallIcon'} />
                </div>
              )}
            </div>
          )}
          {/* 헤더 */}
          <div
            className={'displayFlexColumn'}
            style={{ width: '100%', gap: '8px', padding: '0 8px' }}>
            <div>
              <Typography variant={'subtitleMedium'}>
                <span className={'subtitleBold'}>{userName}</span>
                {t('header.title01')}
                <br />
                {t('header.title02')}
              </Typography>
            </div>
          </div>
          {/* 날짜 */}
          {qnaList && qnaList.length > 0 && (
            <div className={'displayFlex'} style={{ width: '100%', justifyContent: 'center' }}>
              <Typography {...{ variant: 'body2Medium', color: 'GrayScale-500' }}>
                {today}
              </Typography>
            </div>
          )}
          {/* 채팅 컴포넌트들 */}
          <div className={'aiQnaArea'}>
            {qnaList &&
              qnaList.map((item, index) => {
                switch (item.type) {
                  case 'Q':
                    return <QuestionBox key={`q-${item.idx}-${index}`} text={item.message} />;
                  case 'A':
                    const flags = checkMessageFlags(item.message);
                    const isLastAnswer = !qnaList.slice(index + 1).some(msg => msg.type === 'A');
                    return (
                      <AnswerBox
                        key={`a-${item.idx}-${index}`}
                        text={item.message}
                        flags={flags}
                        resFlag={isLastAnswer && resFlag && !isLoading}
                        buttons={renderAnswerButtons(flags)}
                      />
                    );
                  case 'error':
                    return (
                      <FailBox
                        {...{
                          key: `f-${item.idx}-${index}`,
                          text: item.message,
                          hasChatList: currentChatList.length > 1, // currentChatList에 오류 메세지만 존재할 경우, 재시도 버튼 표시 X
                          handleReset,
                          handleRetry,
                          openGitple,
                          handleCallCenter,
                          callcenter,
                          isChatAvailable,
                        }}
                      />
                    );
                  default:
                    return null;
                }
              })}
            {isLoading && <LoadingBox systemMsg={parseLinkButtons(systemMsg)} />}
          </div>
        </div>
        {/* 입력창 */}
        <div className={'qContentArea'}>
          <TextField
            {...{
              value: qContent,
              onChange: e => {
                dispatch(setQContent(e.target.value));
              },
              placeholder: t('placeholder'),
              onKeyUp: () => qContent && sendQuestion(), // qContent 존재 시에만 실행 (함수 연속 호출 방지)
              width: '100%',
              inputStyle: {
                background: '#EDF2FA',
                border: '1px solid #7A5AF8',
                padding: '10px 16px',
                fontSize: '16px',
                fontWeight: '500',
                lineHeight: '22px',
              },
              disabled: hasError,
            }}
          />
          <Button
            {...{
              imgSrc: hasError ? sendIconDis : sendIcon,
              style: { padding: '10px' },
              onClick: () => sendQuestion(),
              // onClick: sendQuestion, // TEST: 테스트 코드 (서버에서 에러 발생 시키기)
              disabled: hasError,
            }}
          />
        </div>
        {/* footer */}
        {!isInputFocused && (
          <div className={'aiAssistantInfoContainer'}>
            <div className={'displayFlex'} style={{ gap: '8px' }}>
              <img src={aiInfoIcon} alt={'aiInfoIcon'} />
              <Typography {...{ variant: 'captionBold', color: 'GrayScale-700' }}>
                {t('infoBox.title')}
              </Typography>
            </div>
            <div className={'displayFlex'} style={{ gap: '8px' }}>
              <Typography {...{ variant: 'captionMedium', color: 'GrayScale-700' }}>
                {t('infoBox.desc01')}
                {t('infoBox.desc02')}
              </Typography>
            </div>
          </div>
        )}
      </AiAssistantStyled>

      {/* [내정보] navigate("/myinfo") 대신 사용 이유: onClose 전달 */}
      <MyInfo {...{ isOpen: isMyInfoOpened, onClose: () => setMyInfoOpened(false) }} />
      {/* [연말정산 일정] */}
      {isSchOpened && (
        <ScheduleScreen
          {...{
            isOpen: isSchOpened,
            onClose: () => setIsSchOpened(false),
          }}
        />
      )}
      {/* 탭 이동 시, 확인  */}
      <SlideDialogV
        {...{
          isOpen: isConfirmOpened,
          onClose: () => setIsConfirmOpened(false),
          title: '잠깐! 주의하세요',
          description: '이동 시 대화 내용이 초기화됩니다.',
          buttons: [
            { label: '네, 이동하겠습니다.', onClick: goToResult },
            {
              label: '아니요, 계속 대화할래요.',
              onClick: () => setIsConfirmOpened(false),
              color: 'secondary',
            },
          ],
        }}
      />
    </>
  );
};

export default AiAssistant;
